import { normalizeCompareDateKey } from './statisticsCompareConfig';
import { buildLineCompareAnchorFromOrderRange } from './statisticsComparePresets';
import { TREND_MODE } from './trendMonthlyConstants';

export const ORDER_DATE_QUICK_PICK_CONFIRMED = 'orderDateQuickPickConfirmed';
/** 清空下单日期：交回标题档当年，不把默认年区间当成筛选自选 */
export const RELEASE_OVERVIEW_PERIOD = 'releaseOverviewPeriod';

export const buildOrderDateRangeKey = (startDate, endDate) => `${normalizeCompareDateKey(startDate)}|${normalizeCompareDateKey(endDate)}`;

/** 日期控件展示值（与 committed 一致，改完 debounce 自动刷新） */
export const resolveOrderDateInputValues = (filters = {}) => ({
	startDate: filters.startDate,
	endDate: filters.endDate,
});

/** 比较 pending 时去掉元字段 */
export const normalizeFiltersForPendingCompare = (filters = {}) => {
	const {
		orderDateInputStart,
		orderDateInputEnd,
		[ORDER_DATE_QUICK_PICK_CONFIRMED]: _confirmed,
		[RELEASE_OVERVIEW_PERIOD]: _release,
		...rest
	} = filters;
	return rest;
};

const clearCompareSegments = (next) => {
	next.customComparePeriods = [];
	next.trendMode = TREND_MODE.PERIODS;
	next.trendMonthlyYears = [];
	next.trendCompareAxisUnit = null;
	next.trendAxisMode = 'time';
	return next;
};

const stripOrderDatePatchMeta = (patch = {}) => {
	const { [ORDER_DATE_QUICK_PICK_CONFIRMED]: _confirmed, [RELEASE_OVERVIEW_PERIOD]: _release, ...rest } = patch;
	return rest;
};

/** 下单日期写入 draft；对比段清理由 apply 时按相对 applied 的日期变更处理 */
export const mergeStatisticsOrderDatePatch = (prev = {}, patch = {}, { anchorCustomized = false } = {}) => {
	if (!('startDate' in patch) && !('endDate' in patch)) {
		return { filters: { ...prev, ...stripOrderDatePatchMeta(patch) }, resetAnchorCustomized: false, setAnchorCustomized: false };
	}

	const datePatch = stripOrderDatePatchMeta(patch);
	const nextStart = 'startDate' in patch ? patch.startDate : prev.startDate;
	const nextEnd = 'endDate' in patch ? patch.endDate : prev.endDate;
	const datesChanged = buildOrderDateRangeKey(prev.startDate, prev.endDate) !== buildOrderDateRangeKey(nextStart, nextEnd);

	let next = { ...prev, ...datePatch, startDate: nextStart, endDate: nextEnd };

	if ('trendAnchor' in patch) {
		next.trendAnchor = patch.trendAnchor;
	}

	const resetAnchorCustomized = datesChanged && Boolean(anchorCustomized) && !('trendAnchor' in patch);

	return { filters: next, resetAnchorCustomized, setAnchorCustomized: false };
};

/** apply 时：相对已生效区间变更则清对比段并补基准（选期带入的 trendAnchor 保留） */
export const applyOrderDateSideEffectsOnApply = (prevApplied = {}, nextDraft = {}, { anchorCustomized = false } = {}) => {
	const datesChanged =
		buildOrderDateRangeKey(prevApplied.startDate, prevApplied.endDate) !== buildOrderDateRangeKey(nextDraft.startDate, nextDraft.endDate);
	if (!datesChanged || anchorCustomized) return nextDraft;

	const next = { ...nextDraft };
	clearCompareSegments(next);

	if (!next.trendAnchor?.startDate || !next.trendAnchor?.endDate) {
		next.trendAnchor = buildLineCompareAnchorFromOrderRange(next.startDate, next.endDate);
	}

	return next;
};

/** 应用/重置后去掉 staging 字段 */
export const sanitizeStatisticsFilters = (filters = {}) => {
	const {
		orderDateInputStart,
		orderDateInputEnd,
		[ORDER_DATE_QUICK_PICK_CONFIRMED]: _confirmed,
		[RELEASE_OVERVIEW_PERIOD]: _release,
		...rest
	} = filters;
	return rest;
};
